import { render, staticRenderFns } from "./PizzaWFilledIcon.vue?vue&type=template&id=55ff93d0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports